import React from 'react';
import Button from './Button';
import ScheduleEventAttendance from './ScheduleEventAttendance';

export interface SyncOptionProps {
  text: string;
  syncVar: string;
  target: string;
  portraits?: string[] | undefined;
  unclickedPortraits?: string[] | undefined;
  onSelect: (syncVar: string, target: string) => void;
  disabled?: boolean;
  customColor?: string | undefined;
  className?: string | undefined;
}

const SyncOption: React.FC<SyncOptionProps> = ({
  text,
  syncVar,
  target,
  portraits,
  unclickedPortraits,
  onSelect,
  disabled = false,
  customColor,
  className = ''
}) => {
  const handleClick = () => {
    if (!disabled) {
      onSelect(syncVar, target);
    }
  };

  const hasPortraits = Array.isArray(portraits) && portraits.length > 0;

  return (
    <div className={`sync-option-wrapper inline-option-full-width-wrapper sync-option-flex ${className}`}>
      <Button
        variant="glass-primary"
        size="md"
        fullWidth
        disabled={disabled}
        onClick={handleClick}
        customColor={customColor}
        className="sync-option-button min-h-[48px] text-center justify-center"
        data-testid="sync-option-button"
        aria-label={`Sync option: ${text}`}
      >
        {text}
      </Button>
      {hasPortraits && (
        <div className="sync-option-portraits" style={{ order: -1 }}>
          <ScheduleEventAttendance
            requiredPortraits={portraits}
            absentPortraits={unclickedPortraits}
          />
        </div>
      )}
    </div>
  );
};

export default SyncOption;
